import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import fetchVehicleRating from '~/services/vdp/fetchVehicleRating';
import { generateErrorLogger } from '~/utilities/loggers';
import calculateRatingsAndDistribution from '~/utilities/vdp/calculateRatingsAndDistribution';

export default function useGetVehicleRating() {
  const {
    vehicleRating: { setData, setError, setLoading }
  } = useContext(GlobalContext);
  const { make = '', model = '', trim = '', year = 0 } = useGetVehicleDetails();

  useEffectWithController(
    controller => {
      setLoading();

      fetchVehicleRating({ make, model, trim, year }, controller)
        .then(response => {
          setData(
            calculateRatingsAndDistribution(response.data.summary.rating_counts)
          );
        })
        .catch(
          generateErrorLogger(
            'Fetch vehicle rating',
            {},
            { callback: setError }
          )
        );
    },
    [make, model, setData, setError, setLoading, trim, year]
  );
}
